import dayjs, { Dayjs } from 'dayjs';
import LocationService from '@/domain/Location/LocationService';

// Calendar format
export const calendarFormat = 'YYYY-MM-DD h:mm a';

// Parsed sensors and filtering logic
export const parsedSensors: any = [];
const seen = new Set();
export const sensores = parsedSensors
	.map((item: string) => JSON.parse(item))
	.filter((item: any) => {
		const tuple = JSON.stringify([item.originalParameterId, item.originalSourceSerialNumber]);
		if (seen.has(tuple)) {
			return false;
		}
		seen.add(tuple);
		return true;
	});

// Utility function to round to nearest 5 minutes
export function roundToNearest5Minutes(date: any) {
	const dt = dayjs(date);
	const minutes = dt.minute();
	const roundedMinutes = Math.round(minutes / 5) * 5;
	return dt.minute(roundedMinutes).second(0);
}

// Date calculations
const hoy = new Date();
const semana = 1000 * 60 * 60 * 24 * 1;
const fec_init = hoy.getTime() - semana;
const fec_end = hoy.getTime() + semana;

// Global date from localStorage
const globalDate = localStorage.getItem('globalDate');

// Initial context configuration
export const initialContext = {
	showNotifications: false,
	showParamsCard: false,
	isExpandedParamsCard: false,
	isPastForecastExpandedParamsCard: false,
	selectedSensors: sensores,
	selectedLocation: null,
	infraToShow: '',
	expandLeftMenu: false,
	selectedDate: globalDate
		? [dayjs(globalDate.split('***')[0]), dayjs(globalDate.split('***')[1])]
		: [roundToNearest5Minutes(fec_init), roundToNearest5Minutes(fec_end)],
	fetchDashboardDataIndex: 0,
	activatedDigitalTwinMode: false,
	activatedInflowMode: false,
	activatedSewerAnalysisMode: false,
};

// Location service instance
export const locationService = new LocationService();

// Interval options for refresh
export const optionsInterval = [
	{ label: 'Off', tooltip: 'Auto refresh disabled.', value: 0 },
	{ label: '5m', tooltip: 'Refresh data every 5 minutes.', value: 300000 },
	{ label: '15m', tooltip: 'Refresh data every 15 minutes.', value: 900000 },
	{ label: '30m', tooltip: 'Refresh data every 30 minutes.', value: 1800000 },
	{ label: '1h', tooltip: 'Refresh data every hour.', value: 3600000 },
];

// Range presets for calendar
export const rangePresetsCalendar: {
	label: string;
	value: [Dayjs, Dayjs];
}[] = [
	{
		label: 'Last 6h',
		value: [dayjs().subtract(6, 'hour'), dayjs()],
	},
	{
		label: 'Last 12h',
		value: [dayjs().subtract(12, 'hour'), dayjs()],
	},
	{
		label: 'Last 24h',
		value: [dayjs().subtract(24, 'hour'), dayjs()],
	},
	{
		label: 'Last 7d',
		value: [dayjs().subtract(7, 'day'), dayjs()],
	},
	{
		label: 'Last 15d',
		value: [dayjs().subtract(15, 'day'), dayjs()],
	},
	{
		label: 'Last 30d',
		value: [dayjs().subtract(30, 'day'), dayjs()],
	},
	{
		label: 'Last 90d',
		value: [dayjs().subtract(90, 'day'), dayjs()],
	},
	{
		label: 'Last 120d',
		value: [dayjs().subtract(120, 'day'), dayjs()],
	},
	{
		label: 'Last 1y',
		value: [dayjs().subtract(1, 'year'), dayjs()],
	},
];

// Utility function to show navigation items
export const showNavItem = (envVar: string, route: string) => {
	const envShowVal = envVar === 'false' ? false : true;
	const routeRestricted = route === '/nwl';
	return envShowVal || !routeRestricted;
};

// Props type definition
export type DashboardLayoutProps = {
	activities: any[];
	security: any;
	readingsList: any[];
	resumeList: any[];
};

export const FUTURE_FEATURES = {
	pastOverflowMode: true,
	heatmapMode: false,
	moduleMenu: false,
	myProfileMenuItem: false,
	alertsMode: false,
} as const;
